<template>
  <div class="tabs-selection-container">
    <div class="tabs-selection-header">
      <mf-tabs-menu v-if="tabsSelectionOptions.length" v-model="tabValue" :tabs-errors="tabsWithErrors" :tabs="tabsSelectionOptions" />
    </div>
    <div class="tabs-selection-content">
      <div v-for="tab in tabsSelectionOptions" :key="tab.type" class="products-table-section">
        <div v-show="tab.id === tabValue">
          <div v-if="showProductsTable(tab)">
            <h2 v-if="tab.groupedItems.length > 0" class="group-title">Produtos desagrupados</h2>
            <products-table
              :key="tab.id"
              :ref="`productsTable_${tab.type}`"
              :type="tab.type"
              :items="tab.items || []"
              :has-offers-schedules-selected="hasOffersSchedulesSelected"
              :initially-products="initiallyProducts"
              :disable-to-remove-remaining-product="disableToRemoveRemainingProduct"
              :disabled="disabled"
              :search="search"
            />
          </div>
          <div v-if="tab.groupedItems.length > 0">
            <div v-for="group in tab.groupedItems" :key="group._id">
              <hr v-if="tab.groupedItems.length > 1 && tab.items.length" class="my-6" />
              <div class="products-group-section">
                <mf-tooltip max-width="360" right variant="secondary">
                  <template #activator>
                    <div class="group-flag">
                      <mf-icon icon="category" color="cinza-d10" size="16" fill />
                      <span>Grupo de produtos</span>
                    </div>
                  </template>
                  Produtos presentes dentro de um grupo não são comunicados separadamente, portanto só é possível editar o nome do grupo, que é enviado na
                  mensagem.
                </mf-tooltip>

                <h2 class="group-name">{{ group[0].name }}</h2>
              </div>
              <products-table
                :key="group[0]._id"
                :ref="`productsTable_${tab.type}_${group[0]._id}`"
                :type="tab.type"
                :items="group || []"
                :has-offers-schedules-selected="hasOffersSchedulesSelected"
                :disable-to-remove-remaining-product="disableToRemoveRemainingProduct"
                :initially-products="initiallyProducts"
                :disabled="disabled"
                :search="search"
                is-group
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mariaCampaign } from '../../../mixins/maria-campaign'
import ProductsTable from './ProductsTable.vue'
export default {
  name: 'TabsSelection',
  components: { ProductsTable },
  mixins: [mariaCampaign],
  props: {
    tab: {
      type: Number,
      default: 0,
    },
    search: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tabsValidations: {
      type: Array,
      default: () => [],
    },
    initiallyProducts: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loading: false,
    hasSelectedProducts: false,
  }),
  computed: {
    tabValue: {
      get() {
        return this.tab
      },
      set(value) {
        this.$emit('update:tab', value)
      },
    },
    tabsSelectionOptions() {
      let tabsOptions = []
      if (this.offerSalesProducts.length || this.campaign.offer_sales.length) {
        const value =
          this.campaign.offer_sales.length > 0 ? JSON.parse(JSON.stringify(this.campaign.offer_sales)) : JSON.parse(JSON.stringify(this.offerSalesProducts))
        tabsOptions.push(this.getTabValueFromOfferType('offer_sales', value, tabsOptions.length))
      }
      if (this.percentageOfferSalesProducts.length) {
        const value = JSON.parse(JSON.stringify(this.percentageOfferSalesProducts))
        tabsOptions.push(this.getTabValueFromOfferType('percentage_offer_sales', value, tabsOptions.length))
      }
      if (this.takepayOfferSalesProducts.length) {
        const value = JSON.parse(JSON.stringify(this.takepayOfferSalesProducts))
        tabsOptions.push(this.getTabValueFromOfferType('takepay_offer_sales', value, tabsOptions.length))
      }
      if (this.comboOfferSalesProducts.length) {
        const value = JSON.parse(JSON.stringify(this.comboOfferSalesProducts))
        tabsOptions.push(this.getTabValueFromOfferType('combo_offer_sales', value, tabsOptions.length))
      }
      if (this.cashbackAbsoluteOfferSalesProducts.length) {
        const value = JSON.parse(JSON.stringify(this.cashbackAbsoluteOfferSalesProducts))
        tabsOptions.push(this.getTabValueFromOfferType('cashback_absolute_offer_sales', value, tabsOptions.length))
      }
      if (this.cashbackPercentageOfferSalesProducts.length) {
        const value = JSON.parse(JSON.stringify(this.cashbackPercentageOfferSalesProducts))
        tabsOptions.push(this.getTabValueFromOfferType('cashback_percentage_offer_sales', value, tabsOptions.length))
      }
      if (this.pointsOfferSalesProducts.length) {
        const value = JSON.parse(JSON.stringify(this.pointsOfferSalesProducts))
        tabsOptions.push(this.getTabValueFromOfferType('points_offer_sales', value, tabsOptions.length))
      }

      return tabsOptions
    },
    disableToRemoveRemainingProduct() {
      let totalProductsCount = 0
      this.tabsSelectionOptions.map((tabOptions) => {
        const countUngroupedProducts = tabOptions.items.filter((product) => {
          const hasOfferSales = this.campaign.offer_sales.length > 0
          const isUngrouped = !product?.isGroup && !product?.groupInfo
          const hasNoGroupId = !product?.group_id

          return hasOfferSales ? isUngrouped : hasNoGroupId
        }).length

        const countGroups = tabOptions.groupedItems.length

        totalProductsCount += countUngroupedProducts + countGroups
      })

      return totalProductsCount === 1
    },
    hasOffersSchedulesSelected() {
      return !this.campaign.offer_sales.length && this.campaign.offer_schedules.length > 0
    },
    tabsWithErrors() {
      const errors = []
      this.tabsValidations.forEach((element, index) => {
        if (!element) errors.push(index)
      })
      return errors
    },
    offerSalesProducts() {
      return this.getProducstArrayFromOfferType('offer_sales')
    },
    cashbackAbsoluteOfferSalesProducts() {
      return this.getProducstArrayFromOfferType('cashback_absolute_offer_sales')
    },
    cashbackPercentageOfferSalesProducts() {
      return this.getProducstArrayFromOfferType('cashback_percentage_offer_sales')
    },
    pointsOfferSalesProducts() {
      return this.getProducstArrayFromOfferType('points_offer_sales')
    },
    percentageOfferSalesProducts() {
      return this.getProducstArrayFromOfferType('percentage_offer_sales')
    },
    takepayOfferSalesProducts() {
      return this.getProducstArrayFromOfferType('takepay_offer_sales')
    },
    comboOfferSalesProducts() {
      return this.getProducstArrayFromOfferType('combo_offer_sales')
    },
  },
  methods: {
    showProductsTable(tab) {
      return tab.items.filter((product) => !product.group_rules_exhibition).length > 0
    },
    getGroupedProducts(productsList) {
      if (Array.isArray(productsList) && productsList.length > 0 && Array.isArray(productsList[0])) {
        return productsList
      }

      const productsBelongToAGroup = productsList.filter((product) => product?._id && product?.group_rules_exhibition)

      const groupedProducts = {}
      productsBelongToAGroup.forEach((product) => {
        const groupId = product.groupInfo ? product.groupInfo._id : product._id
        if (!groupedProducts[groupId]) {
          groupedProducts[groupId] = []
        }
        groupedProducts[groupId].push(product)
      })

      if (productsBelongToAGroup.length) {
        const groups = Object.keys(groupedProducts).map((groupId) => {
          const productsInGroup = groupedProducts[groupId]
          const firstProduct = productsInGroup[0]

          const groupNameRow = {
            ...firstProduct,
            name: firstProduct?.group_name,
            _id: firstProduct.groupInfo ? firstProduct.groupInfo._id : firstProduct._id,
            original_group_name: firstProduct?.group_name,
          }

          const keysToDelete = ['sku', 'eans', 'selectedEans']
          keysToDelete.forEach((key) => delete groupNameRow[key])

          return [groupNameRow, ...productsInGroup]
        })

        return groups
      } else return []
    },
    getTabValueFromOfferType(type, productsList, id) {
      const typesTitles = {
        offer_sales: 'Desconto absoluto',
        cashback_absolute_offer_sales: 'Cashback absoluto',
        cashback_percentage_offer_sales: 'Cashback percentual',
        points_offer_sales: 'Pontos',
        percentage_offer_sales: 'Desconto percentual',
        takepay_offer_sales: 'Leve e pague',
        combo_offer_sales: 'Combo',
      }

      const formattedBaseOffer = (offer, sales) => {
        return {
          isGroup: true,
          group_name: sales.group_name || offer.group_name || offer.name,
          groupInfo: {
            _id: offer._id,
            __typename: 'ProductsGroup',
          },
          group_rules_exhibition: offer.group_rules_exhibition,
          group_image_url: offer.group_image_url,
          _id: sales._id || sales?.product?._id || offer._id,
          sku: sales.sku,
          ean: sales.ean,
          eans: sales.eans,
          name: sales.name || sales?.product?.name,
          offer_schedule_id: offer?.offer_schedule_id || offer?.offer_schedule?._id,
          image: sales?.product?.image,
          selectedEans: sales.eans,
          active: sales.active,
        }
      }

      if (type === 'offer_sales' && this.itsGetCampaignFromApi) {
        productsList = productsList
          .map((offer, index) => {
            if (!offer?.offer_sales) return offer
            return offer?.offer_sales?.map((sales) => {
              return {
                price_1: sales.price_1 || offer.offer_sales[index]?.price_1 || offer.price_1,
                price_2: sales.price_2 || offer.offer_sales[index]?.price_2 || offer.price_2,
                maximum_per_client: offer.maximum_per_client,
                minimum_per_client: offer.minimum_per_client,
                ...formattedBaseOffer(offer, sales),
              }
            })
          })
          ?.flat()
      }

      if (type === 'cashback_absolute_offer_sales' && this.itsGetCampaignFromApi) {
        productsList = productsList
          .map((offer, index) => {
            if (!offer?.cashback_absolute_offer_sales) return offer
            return offer?.cashback_absolute_offer_sales?.map((sales) => {
              return {
                expiration_cashback: {
                  ...offer?.expiration_cashback,
                },
                maximum_per_client: offer.maximum_per_client,
                minimum_per_client: offer.minimum_per_client,
                price: offer.price,
                cashback_absolute: offer.cashback_absolute,
                ...formattedBaseOffer(offer, sales),
              }
            })
          })
          ?.flat()
      }

      if (type === 'cashback_percentage_offer_sales' && this.itsGetCampaignFromApi) {
        productsList = productsList
          .map((offer, index) => {
            if (!offer?.cashback_percentage_offer_sales) return offer
            return offer?.cashback_percentage_offer_sales?.map((sales) => {
              return {
                expiration_cashback: {
                  ...offer?.expiration_cashback,
                },
                maximum_per_client: offer.maximum_per_client,
                minimum_per_client: offer.minimum_per_client,
                price_1: offer.price_1,
                cashback_percentage: offer.cashback_percentage,
                ...formattedBaseOffer(offer, sales),
              }
            })
          })
          ?.flat()
      }

      if (type === 'points_offer_sales' && this.itsGetCampaignFromApi) {
        productsList = productsList
          .map((offer, index) => {
            if (!offer?.points_offer_sales) return offer
            return offer?.points_offer_sales?.map((sales) => {
              return {
                maximum_per_client: offer.maximum_per_client,
                minimum_per_client: offer.minimum_per_client,
                price: offer.price,
                additional_points_rate: offer.additional_points_rate,
                ...formattedBaseOffer(offer, sales),
              }
            })
          })
          ?.flat()
      }

      if (type === 'percentage_offer_sales' && this.itsGetCampaignFromApi) {
        productsList = productsList
          .map((offer, index) => {
            if (!offer?.percentage_offer_sales) return offer
            return offer?.percentage_offer_sales?.map((sales) => {
              return {
                maximum_per_client: offer.maximum_per_client,
                minimum_per_client: offer.minimum_per_client,
                percentage_discount: offer.percentage_discount,
                ...formattedBaseOffer(offer, sales),
              }
            })
          })
          ?.flat()
      }

      if (type === 'takepay_offer_sales' && this.itsGetCampaignFromApi) {
        productsList = productsList
          .map((offer, index) => {
            if (!offer?.takepay_offer_sales) return offer
            return offer?.takepay_offer_sales?.map((sales) => {
              return {
                pay: offer.pay,
                take: offer.take,
                maximum_per_client: offer.maximum_per_client,
                ...formattedBaseOffer(offer, sales),
              }
            })
          })
          ?.flat()
      }

      productsList = Array.from(new Map(productsList.map((item) => [item.ean, item])).values())
      const groupedItems = this.getGroupedProducts(productsList)

      if (type === 'offer_sales' && this.campaign?.offer_sales?.length > 0) {
        this.setOfferSalesProducts(productsList)
      }

      const tabValue = {
        id,
        type,
        name: typesTitles[type],
        itemsLength: productsList.length + groupedItems.filter((product) => product?.sku).length,
        items: productsList,
        groupedItems,
        haveLength: true,
        disabled: false,
      }

      return tabValue
    },
    setOfferSalesProducts(products) {
      this.setOmniCampaignKey({ key: 'offer_sales', payload: products })
    },
    getProducstArrayFromOfferType(key) {
      let offerProducts = []
      this.campaign.offer_schedules.map((offer) => {
        if (offer[key].length) {
          const mappedProducts = offer[key].map((product) => {
            return {
              ...product,
              offer_schedule_id: product.offer_schedule_id || product?.offer_schedule?._id || offer?.offer_schedule?._id,
            }
          })
          offerProducts = [...offerProducts, ...mappedProducts]
        }
      })

      return offerProducts
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-selection-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  h2.group-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 19.2px;
    letter-spacing: 0.4px;
    color: $cinza-d10;
    margin-bottom: 32px;
  }

  .products-group-section {
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
    .group-flag {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      background-color: $cinza-l80;
      border-radius: 4px;
      padding: 4px 8px;
      span {
        font-size: 14px;
        font-weight: 600;
        line-height: 16px;
        text-align: center;

        color: $cinza-d10;
      }
    }
    h2.group-name {
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      letter-spacing: 0.4px;
      color: $cinza-d10;
    }
  }

  hr {
    color: $cinza-l50;
  }
}
</style>
